import AllResourcesSwitch from '../AllResourcesSwitch';
import ClosedTasksSwitch from '../ClosedTasksSwitch';
import './FooterSwitches.css';

const FooterSwitches: React.FC = () => {
  return (
    <div className="switches">
      <AllResourcesSwitch />
      <ClosedTasksSwitch />
    </div>
  );
};

export default FooterSwitches;
